/**
 * @generated SignedSource<<b9296cffe1ac04e9b631a01c501eaadd>>
 * @relayHash 8ccaa6ee3a3a1739adc522595987afb0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2fe1e22c47a6599202eed7d6245c18ebe9a0228df5f6b01987de167062cdf3ca

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBoardQuery } from './JiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<JiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2fe1e22c47a6599202eed7d6245c18ebe9a0228df5f6b01987de167062cdf3ca",
    "metadata": {},
    "name": "JiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
